<form>
	<div class="row row-gap-3 px-4">
		<div class="col-xl-8">

			<div class="d-flex justify-content-between">
				<div class="form-group form-group-bordered w-auto px-4">
					<label data-testid="SUBSYS5_HISTORYFILTERS_TYPE_LBL" for="type" class="label-bordered px-3">
						{{ labels().HISTORY_FILTERS_COMPONENT_TYPE }}
					</label>
					<div class="custom-control custom-checkbox custom-control-inline">
						<input data-testid="SUBSYS5_HISTORYFILTERS_PINSITECARE_INPUT" type="checkbox" name="type" id="pin-site-care"
							class="custom-control-input" [checked]="filters()!.pinSiteCare"
							(change)="filters()!.pinSiteCare = !filters()!.pinSiteCare">
						<label data-testid="SUBSYS5_HISTORYFILTERS_PINSITECARE_LBL" for="pin-site-care"
							class="custom-control-label">
							{{ labels().HISTORY_FILTERS_COMPONENT_PIN_SITE_CARE }}
						</label>
					</div>
					<div class="custom-control custom-checkbox custom-control-inline">
						<input data-testid="SUBSYS5_HISTORYFILTERS_STRUTADJUST_INPUT" type="checkbox" name="type" id="struts-adjust"
							class="custom-control-input" [checked]="filters()!.strutsAdj"
							(change)="filters()!.strutsAdj = !filters()!.strutsAdj">
						<label data-testid="SUBSYS5_HISTORYFILTERS_STRUTADJUST_LBL" for="struts-adjust"
							class="custom-control-label">
							{{ labels().HISTORY_FILTERS_COMPONENT_STRUTS_ADJUST }}
						</label>
					</div>
					<div class="custom-control custom-checkbox custom-control-inline">
						<input data-testid="SUBSYS5_HISTORYFILTERS_PRESCSYNC_INPUT" type="checkbox" name="type" id="prescr-sync"
							class="custom-control-input" [checked]="filters()!.prescrSync"
							(change)="filters()!.prescrSync = !filters()!.prescrSync">
						<label data-testid="SUBSYS5_HISTORYFILTERS_PRESCSYNC_INPUT" for="prescr-sync" class="custom-control-label">
							{{ labels().HISTORY_FILTERS_COMPONENT_PRESCR_SYNC }}
						</label>
					</div>
					@if (isDiary()) {
					<div class="custom-control custom-checkbox custom-control-inline">
						<input data-testid="SUBSYS5_HISTORYFILTERS_OTHER_INPUT" type="checkbox" name="type" id="other"
							class="custom-control-input" [checked]="filters()!.other" (change)="filters()!.other = !filters()!.other">
						<label data-testid="SUBSYS5_HISTORYFILTERS_OTHER_LBL" for="other" class="custom-control-label">
							{{ labels().HISTORY_FILTERS_COMPONENT_OTHER }}
						</label>
					</div>
					}
				</div>
				@if (isReadCheckboxVisible()) {
				<div class="form-group w-auto mx-5 pb-0">
					<label for="read">&nbsp;</label>
					<div class="custom-control custom-checkbox custom-control-inline">
						<input data-testid="SUBSYS5_HISTORYFILTERS_SHOWREAD_INPUT" type="checkbox" name="read" id="read"
							class="custom-control-input" [checked]="filters()!.other" (change)="filters()!.other = !filters()!.other">
						<label data-testid="SUBSYS5_HISTORYFILTERS_SHOWREAD_LBL" for="read" class="custom-control-label">
							{{ labels().HISTORY_FILTERS_COMPONENT_SHOW_READ }}
						</label>
					</div>
				</div>
				}
			</div>

		</div>
		<div class="col-xl-4">
			<div class="d-flex">

				<div class="form-group pb-0">
					<label data-testid="SUBSYS5_HISTORYFILTERS_DATEFROM_LBL" for="from-date">
						{{ labels().HISTORY_FILTERS_COMPONENT_DATE_FROM }}
					</label>
					<div class="input-group wrapper-calendar p-0" #fromDateTarget>
						<i data-testid="SUBSYS5_HISTORYFILTERS_DATEFROM_TOGGLE_BTN"
							class="material-icons input-group-append icon-calendar" (click)="fromDatePicker.toggle()"
							(keypress)="fromDatePicker.toggle()">today</i>
						<input data-testid="SUBSYS5_HISTORYFILTERS_DATEFROM_INPUT" type="text" name="from-date" id="from-date"
							class="form-control text-white" [placeholder]="labels().HISTORY_FILTERS_COMPONENT_DATE_FROM"
							[ngModel]="fromDateFormat" [ngModelOptions]="{standalone: true}" readonly>
						<i data-testid="SUBSYS5_HISTORYFILTERS_DATEFROM_CLEAR_BTN"
							class="material-icons input-group-append align-self-center md-18" (click)="clearFromDate()"
							(keypress)="clearFromDate()">clear</i>
					</div>
				</div>
				<datepicker data-testid="SUBSYS5_HISTORYFILTERS_DATEFROM_DATEPICKER" #fromDatePicker
					[value]="filters()!.dateFrom ?? null" (dateChanged)="updateFromDate($event)" [positionTarget]="fromDateTarget"
					placement="bottom-right" />

				<div class="form-group pb-0 ms-5">
					<label data-testid="SUBSYS5_HISTORYFILTERS_DATETO_LBL" for="to-date">
						{{ labels().HISTORY_FILTERS_COMPONENT_DATE_TO }}
					</label>
					<div class="input-group wrapper-calendar p-0" #toDateTarget>
						<i data-testid="SUBSYS5_HISTORYFILTERS_DATETO_TOGGLE_BTN"
							class="material-icons input-group-append icon-calendar" (click)="toDatePicker.toggle()"
							(keypress)="toDatePicker.toggle()">today</i>
						<input data-testid="SUBSYS5_HISTORYFILTERS_DATETO_INPUT" type="text" name="to-date" id="to-date"
							class="form-control text-white" [placeholder]="labels().HISTORY_FILTERS_COMPONENT_DATE_TO"
							[ngModel]="toDateFormat" [ngModelOptions]="{standalone: true}" readonly>
						<i data-testid="SUBSYS5_HISTORYFILTERS_DATETO_CLEAR_BTN"
							class="material-icons input-group-append align-self-center md-18" (click)="clearToDate()"
							(keypress)="clearToDate()">clear</i>
					</div>
				</div>
				<datepicker data-testid="SUBSYS5_HISTORYFILTERS_DATETO_DATEPICKER" #toDatePicker
					[value]="filters()!.dateTo ?? null" (dateChanged)="updateToDate($event)" [positionTarget]="toDateTarget"
					placement="bottom-right" />

			</div>
		</div>
	</div>

	<div class="row mt-4">
		<div class="col d-flex justify-content-end">
			<button data-testid="SUBSYS5_HISTORYFILTERS_CLEAR_BTN" class="btn btn-secondary-outline me-4" (click)="clear()">
				{{ labels().HISTORY_FILTERS_COMPONENT_CLEAR_BTN }}
			</button>
			<button data-testid="SUBSYS5_HISTORYFILTERS_SEARCH_BTN" class="btn btn-primary" (click)="search()">
				{{ labels().HISTORY_FILTERS_COMPONENT_SEARCH_BTN }}
			</button>
		</div>
	</div>

</form>